// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__Ffqop","errorLogs":"styles_errorLogs__2bVfH"};